import { Label } from '@frontend/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@frontend/components/ui/select';
import { cn } from '@frontend/lib/utils';
import { useDirectoryCategories } from '@frontend/shared/hooks/useDirectory';

export interface CategorySelectProps {
  value?: string;
  onChange: (categoryId: string) => void;
  isRequired?: boolean;
  isDisabled?: boolean;
  error?: string;
  label?: string;
  placeholder?: string;
  includeArchived?: boolean;
  maxW?: string | number;
}

export function CategorySelect({
  value,
  onChange,
  isRequired = false,
  isDisabled = false,
  error,
  label = 'Category',
  placeholder = 'Select a category',
  maxW,
}: CategorySelectProps) {
  const allCategories = useDirectoryCategories() || [];

  return (
    <div
      className={cn('space-y-2')}
      style={maxW ? { maxWidth: maxW } : undefined}
    >
      {label && (
        <Label className="text-sm font-medium">
          {label}
          {isRequired && <span className="text-red-500 ml-1">*</span>}
        </Label>
      )}
      <Select
        value={value || ''}
        onValueChange={onChange}
        disabled={isDisabled}
      >
        <SelectTrigger className={cn('bg-white', error && 'border-red-500')}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {allCategories.map((category) => (
            <SelectItem key={category.id} value={category.id}>
              {category.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
}
